import { Col, Row } from "react-bootstrap";

//Styles
import "./Checkboxcontainer.css";

//Icons
import { FaRegCalendarAlt } from "react-icons/fa";
import { BsFillInfoCircleFill } from "react-icons/bs";

export function Checkboxcontainer({ children, label, icon, size }) {
  const checkIcon = (icon) => {
    if (icon === "calendar") return <FaRegCalendarAlt size={20} />;
    if (icon === "info") return <BsFillInfoCircleFill size={20} />;
  };

  return (
    <div className="checkbox-section">
      <div className={`checkbox-container ${size ? "auto-size" : ""}`}>
          <Row className="checkbox-row">
            <Col xs="12" className="checkbox-header">
              {label}
              {checkIcon(icon)}
            </Col>
          </Row>
          <Row className="checkbox-content">
            {children}
          </Row>
      </div>
    </div>
  );
}
